import TableSearch from "@/components/table_search/TableSearch";
import Header from "../_components/Header";
import PaginationEl from "../_components/PaginationEl";
import { useState } from "react";
import { useDebounce } from "@/hooks/useCustomDebounce";
import { useQuery } from "@tanstack/react-query";
import api from "@/context/apiRequest";
import { nationalitiesBreadcrumbList } from "@/l-data/admin/breadcrumLists";
import ApiError from "@/components/error404/ApiError";
import TableSkeleton from "@/components/skeletons/TableSkeleton";
import AddElement from "../_components/AddElement";
import AddNewUserForm from "./_components/AddNewNationalityForm";
// import NationalitiesTable from "./_components/NationalitiesTable";

export default function Nationalities() {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 1000);
  const [open, setOpen] = useState<boolean>(false);

  const {
    data: nationalities,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["admin-nationalities", debouncedSearch, page],
    queryFn: async () =>
      await api()
        .get(`/api/v1/admin/nationalities?search=${search}&page=${search ? 1 : page}`)
        .then((res) => {
          return res?.data?.data;
        }),
  });

  return (
    <main>
      <Header title={"Nationalities Display"} list={nationalitiesBreadcrumbList} />
      <div className="flex items-center justify-between py-6">
        <TableSearch search={search} setSearch={setSearch} />
        <AddElement
          open={open}
          setOpen={setOpen}
          title="Add New Nationality"
          subtitle="Fill all required inputs to add new nationality"
          formEl={<AddNewUserForm setOpen={setOpen} />}
        />
      </div>
      {/* {nationalities && <NationalitiesTable data={nationalities} />} */}
      {nationalities && <PaginationEl setPage={setPage} data={nationalities} />}
      {isLoading && <TableSkeleton />}
      {isError && <ApiError />}
    </main>
  );
}
